import { render, staticRenderFns } from "./AdminFaqList.vue?vue&type=template&id=5155abc9&"
import script from "./AdminFaqList.vue?vue&type=script&lang=js&"
export * from "./AdminFaqList.vue?vue&type=script&lang=js&"
import style0 from "./AdminFaqList.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports